import React from 'react';
import { useSeparator } from '@react-aria/separator';
import { useSpacing } from '../../api/spacing/useSpacing';
import { pickComponentCommonProps } from '../../interfaces/commonProps';
import { StyledDivider } from './Divider.styles';
export const Divider = React.forwardRef(function Divider({ as, ...restProps }, ref) {
    const { separatorProps } = useSeparator({ elementType: as, ...restProps });
    const commonProps = pickComponentCommonProps(restProps);
    const outerSpacing = useSpacing(restProps);
    return (React.createElement(StyledDivider, { ref: ref, as: as, ...separatorProps, ...commonProps, outerSpacing: outerSpacing }));
});
//# sourceMappingURL=Divider.js.map